import { ExternalLink, LogOut } from 'lucide-react';
import { useAuth } from './useAuth';

const landingUrl: string | undefined = import.meta.env.VITE_ORBIS_MARKETPLACE_LANDING_URL;

/**
 * Full-page block shown when GET /marketplace/access returns 403 — the user is
 * signed in but their tenant has no active Azure Marketplace entitlement.
 */
export function SubscriptionRequired() {
  const { user, signOut } = useAuth();

  return (
    <main className="flex min-h-screen items-center justify-center bg-brand-navy-900 px-4 py-10">
      <section className="flex w-full max-w-[480px] flex-col items-center gap-6 rounded-[20px] border border-white/10 bg-white/5 px-8 py-12 text-center backdrop-blur-2xl sm:px-12">
        <p className="text-xs uppercase tracking-[0.3em] text-brand-orange">
          Subscription required
        </p>
        <h1 className="text-[26px] font-semibold leading-tight text-white">
          Your organization doesn’t have an active Orbis subscription
        </h1>
        <p className="text-[15px] leading-[1.5] text-white/70">
          {user?.email ? `${user.email} is signed in, but ` : ''}
          access to WisdomX Orbis is licensed through Microsoft Azure Marketplace. Purchase or
          activate a plan, then sign in again.
        </p>

        {landingUrl ? (
          <a
            href={landingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand-orange py-4 text-[16px] font-semibold text-white transition hover:opacity-95"
          >
            Get Orbis on Azure Marketplace
            <ExternalLink size={18} />
          </a>
        ) : (
          <p className="text-sm text-white/60">
            Contact your administrator to activate an Orbis subscription.
          </p>
        )}

        <button
          type="button"
          onClick={() => void signOut()}
          className="flex items-center gap-2 text-sm text-white/70 transition hover:text-white"
        >
          <LogOut size={16} />
          Sign out
        </button>
      </section>
    </main>
  );
}
